import GroupsPermissions from "./GroupsPermissions";
export default GroupsPermissions;